module.exports = __webpack_public_path__ + "static/testi6-ad30b991718eefc3007e64b1fc0b22cb.jpg";